import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
    GooglePlacesSearchInput,
    Label,
    PoweredByGoogle,
} from '@spothero/ui/backlog';
import EnvironmentUtils from '@spothero/utils/environment';

export default class SearchInput extends Component {
    static propTypes = {
        isMonthly: PropTypes.bool,
        isSearching: PropTypes.bool,
        placeholder: PropTypes.string,
        searchString: PropTypes.string,
        searchBounds: PropTypes.shape({
            swLat: PropTypes.number,
            swLng: PropTypes.number,
            neLat: PropTypes.number,
            neLng: PropTypes.number,
        }),
        showLabel: PropTypes.bool,
        onSuggestSelect: PropTypes.func,
        onChange: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
    };
    static defaultProps = {
        placeholder: 'Address, Place, City or Venue',
        showLabel: true,
        searchString: '',
    };

    constructor(props) {
        super(props);

        const {searchBounds} = props;
        const isBrowser = EnvironmentUtils.isBrowser();

        this._gmaps = isBrowser ? window.google.maps : null;
        this._bounds =
            isBrowser && searchBounds
                ? new this._gmaps.LatLngBounds(
                      new this._gmaps.LatLng(
                          searchBounds.swLat,
                          searchBounds.swLng
                      ),
                      new this._gmaps.LatLng(
                          searchBounds.neLat,
                          searchBounds.neLng
                      )
                  )
                : null;
    }

    _onClearClick = () => {
        this.props.onChange('');
    };

    _onChange = evt => {
        this.props.onChange(evt.target.value);
    };

    _onSuggestSelect = ({
        label: searchString,
        location,
        id,
        place_id: placeId,
        reference,
        url,
    }) => {
        const {onSuggestSelect, onSubmit} = this.props;
        /* eslint-disable camelcase */
        const submitParams = {
            search_string: searchString,
            latitude: location.lat,
            longitude: location.lng,
            google_places_id: id,
            google_places_place_id: placeId,
            google_places_reference: reference,
        };
        /* eslint-enable camelcase */

        onSubmit(submitParams, true);

        if (onSuggestSelect) {
            onSuggestSelect(searchString);
        }
    };

    render() {
        const {
            isMonthly,
            placeholder,
            searchString,
            isSearching,
            showLabel,
            ...props
        } = this.props;
        const classes = classNames('SearchInput', {
            'SearchInput-searching': isSearching,
        });

        return (
            <GooglePlacesSearchInput
                {...props}
                className={classes}
                placeholder={isMonthly ? 'City, Address or Place' : placeholder}
                country={['us', 'ca']}
                bounds={this._bounds}
                defaultValue={searchString}
                loading={isSearching}
                disabled={isSearching}
                label={showLabel ? <Label>Find Parking Near</Label> : null}
                poweredByGoogleFooter={<PoweredByGoogle />}
                googleMaps={this._gmaps}
                onClear={this._onClearClick}
                onChange={this._onChange}
                onSuggestionSelect={this._onSuggestSelect}
            />
        );
    }
}
